import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function BlurredBackground({ color, color2 }) {
  const [isClient, setIsClient] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsClient(true); // تأیید اینکه در کلاینت هستیم

    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIsMobile();

    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  if (!isClient) return null; // جلوگیری از رندر سمت سرور

  return (
    <div className="top-0 left-0 w-full overflow-hidden -z-10 h-full absolute">
      {/* بافت دانه‌ای ثابت */}

      <div  className="absolute inset-0 pointer-events-none opacity-45 lg:opacity-60 mix-blend-overlay z-20 grain-bg" />


      {/* دسکتاپ: اشکال چرخشی */}
      {!isMobile && (
        <>
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 40, ease: "linear" }}
            style={{ background: color2 }}
            className="absolute w-[600px] h-[600px] rounded-[20%] top-[-150px] right-[2%] blur-[80px] opacity-60 z-10"
          />
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 60, ease: "linear" }}
            style={{ background: color2 }}
            className="absolute w-[700px] h-[700px] rounded-full bottom-[-200px] right-[20%] blur-[80px] opacity-60 z-10"
          />
          <motion.div
            animate={{ rotate: -360 }}
            transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
            style={{ background: color }}
            className="absolute w-[100em] h-[40em] right-[-15%] top-[200px] left-[-40em] rounded-full blur-[80px] opacity-60 z-10"
          />
        </>
      )}

      {/* موبایل: شکل ساده */}
      {isMobile && (
        <div
          style={{ background: color }}
          className="absolute w-[300px] h-[300px] rounded-full top-[20%] left-[10%] blur-[60px] opacity-40"
        />
      )}

      {/* گرادیانت پایین */}
    </div>
  );
}
